import { RouteRecordRaw } from 'vue-router'
import ReservationList from '@/pages/registration/reservation/Reservation.vue'
import DocumentList from '@/pages/document/document-list/DocumentList.vue'
import DocumentRegistrationSingle from '@/pages/registration/registration/single/DocumentSingle.vue'

const routes: RouteRecordRaw[] = [
  {
    path: '/registration/reserved-numbers',
    name: 'number-reservation-list',
    component: ReservationList,
    meta: {
      title: 'Зарезервовані номери',
      resource: 'registration',
    },
  },
  {
    path: '/registration/on-registration',
    name: 'document-list-on-registration',
    component: DocumentList,
    meta: {
      title: 'На реєстрації',
      resource: 'registration',
    },
  },
  {
    path: '/registration/on-registration',
    name: 'document-list-registered',
    component: DocumentList,
    meta: {
      title: 'На реєстрації',
      resource: 'registration',
    },
  },
  {
    path: '/registration/document/:uuid',
    name: 'document-registration-single',
    component: DocumentRegistrationSingle,
    meta: {
      title: 'Документ',
      resource: 'registration',
    },
  },
]

export default routes
